var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2.16016","width":"24.4562","height":"3.05703","transform":"rotate(45 2.16016 0)","fill":"white","key":0}),React.createElement("rect",{"width":"24.4562","height":"3.05703","transform":"matrix(-0.707107 0.707107 0.707107 0.707107 17.293 0)","fill":"white","key":1})]);
}

Close.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Close;

Close.default = Close;
